import moment from 'moment';
import { AnimatePresence, motion } from 'framer-motion';
import { Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { Row } from '~/commonComponents';
import { CheckIcon } from '~/images/icons/CheckIcon';

interface IAutoSaveStatusProps {
  visible?: boolean;
  date?: Date | null;
}

export const AutoSaveStatus = ({ visible = false, date }: IAutoSaveStatusProps) => {
  const formattedDate = date ? moment(date).format('hh:mm a') : '';

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ x: 100, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          exit={{ x: 100, opacity: 0 }}
          transition={{
            duration: 0.4,
            ease: [0.4, 0, 0.2, 1],
          }}
          style={{
            position: 'fixed',
            top: 110,
            right: 50,
            zIndex: 10,
          }}
        >
          <Row
            alignItems="center"
            data-cy="auto-save-status"
            paddingHorizontal={10}
            borderRadius={12}
            border={`1px solid ${colors.neutral[200]}`}
            backgroundColor={colors.shades[0]}
            boxShadow="0 2px 8px rgba(0, 0, 0, 0.1)"
          >
            <CheckIcon size={20} color={colors.success[500]} />
            <Typography as="span" size="body_small">Draft saved • {formattedDate}</Typography>
          </Row>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
